<template>
  <div>
    <!-- 설명 영역 -->
    <div class="mb-12">
      <v-carousel
        cycle
        vertical
        touchless
        height="180"
        hide-delimiters
        :interval="4000"
        :next-icon="false"
        :prev-icon="false"
        hide-delimiter-background
      >
        <v-carousel-item v-for="(text, index) in loadingTexts" :key="index">
          <h1 class="font--m-1" v-html="text"></h1>
        </v-carousel-item>
      </v-carousel>
    </div>
    <img class="width-100" src="@/assets/images/accounts/sales_scraping.gif" alt="한도산출중" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingTexts: [
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
        '잠시만 기다려주세요.<br />한도를 산출하고 있습니다.',
        '9개의 카드사로부터<br />고객님의 매출 정보를 확인 중입니다.',
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
